import { DesignSystem } from '@/src/design-system'

export default function IndexScreen() {
  return <DesignSystem.Loading.Screen />
}
